import PropTypes from 'prop-types';
import React from 'react';

type TextBoxUncontrolledProps = {
  initialValue:string,
  placeholder:string,
  onChange: (e:React.ChangeEvent<HTMLInputElement>) => void,
  disabled: boolean,
  onEnter?: (() => void)|undefined,
  onTabNext?: (() => boolean)|undefined,
  maxLength?: number|undefined,
  [x:string]: any
  focusable?: boolean,
  noborder?: boolean,
};
const TextBoxUncontrolled = React.forwardRef<HTMLInputElement, TextBoxUncontrolledProps>(({
  initialValue,
  placeholder,
  onChange,
  disabled,
  onEnter,
  onTabNext,
  maxLength = undefined,
  focusable = true,
  noborder = false,
  ...other
}, ref) => {
  const dark = false;
  
  let cssClass = dark ? 'e-ifms-input-dark e-outline ifms-tabable' : 'e-ifms-input e-outline ifms-tabable';
  if (noborder) {
    cssClass = `${cssClass} ifms-noborder-input`;
  }
  if ( focusable && !disabled) {
    cssClass = `${cssClass} ifms-tabable-active`;
  }

  function processTabNext(e:React.KeyboardEvent<HTMLInputElement>) {
    if (onTabNext) {
      const tabProcessed = onTabNext();
      if (tabProcessed) {
        e.preventDefault();
        return;
      }
    }
  }

  function onKeyDown(e:React.KeyboardEvent<HTMLInputElement>) {
    const tab = 9;
    const enterKey = 13;

    if (e.keyCode === tab) {
      if (!e.shiftKey) {
        processTabNext(e);
      }
    }
    if (e.keyCode === enterKey) {
      if (onEnter) {
        onEnter();
      }
    }
  }

  return (
    <input
      {...other}
      ref={ref}
      maxLength={maxLength}
      type="text"
      className={cssClass}
      defaultValue={initialValue}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      autoComplete="off"
      list="autocompleteOff"
      data-tooltip="-from-value"
      data-tooltip-onlywhencutoff
    />
  );
});

TextBoxUncontrolled.defaultProps = {
  onChange: () => {},
  initialValue: '',
  disabled: false,
  dark: false,
  placeholder: '',
};

TextBoxUncontrolled.propTypes = {
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  initialValue: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  onTabNext: PropTypes.func,
  maxLength: PropTypes.number,
};

export default React.memo(TextBoxUncontrolled);
